import { render, staticRenderFns } from "./CoachExpSvg.vue?vue&type=template&id=c0d39740&"
import script from "./CoachExpSvg.vue?vue&type=script&lang=js&"
export * from "./CoachExpSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports